/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Liste } from '@mairistem/liste';

import ActeDecesListeTable from './ActeDecesListeTable';

interface ActeDecesListeProps {
  actes?: Array<any>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSort?: any;
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeDecesListe = (props: ActeDecesListeProps) => {
  const {
    actes,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    sidebar,
    ...handlers
  } = props;

  return (
    <Liste
      title="Liste des actes de décès"
      searchable
      search={{
        clearable: true,
        placeholder: "Saisir le nom d'une personne...",
      }}
      {...handlers}
    >
      <Liste.Content>
        <ActeDecesListeTable
          items={actes}
          loading={loading}
          count={count}
          perPage={perPage}
          onLoad={onLoad}
          onSort={onSort}
          sidebar={sidebar}
        />
      </Liste.Content>
    </Liste>
  );
};

export default ActeDecesListe;
